<div class="debug-itrent-absences">
  <h2>Raw absences data</h2>
  <div class="row pb-2">
    <div class="col-2">
      <button type="button" class="btn btn-primary" (click)="getRawResponseForAbsences()">Get absences</button>
    </div>
    <div class="col">
      <input type="text" class="form-control mb-3" [(ngModel)]="employeeId" placeholder="Enter employee id">
      <app-input-date
              [placeholder]="'From date'"
              [(inputDate)]="fromDate"
              [onlyMondays]="true">
      </app-input-date>
      <app-input-date
              [placeholder]="'To date'"
              [(inputDate)]="toDate"
              [onlySundays]="true">
      </app-input-date>
    </div>
  </div>
  <div class="row pb-3">
    <div class="col">
      <textarea class="form-control" rows="5" [(ngModel)]="rawAbsenceResponse"></textarea>
    </div>
  </div>
</div>